const semanticTokens = {
  //This will be translated into a CSS variable like this (--chakra-colors-[colorName])
  colors: {
    primary: {
      default: '#212b36',
    },
    //We can change this later
    secondary: {
      default: 'gray.500',
    },
  },
};

export default semanticTokens;
